class HulkAppsShippingIntegration {

    HULKAPPS_CART_COLLECTIONS_URL = '/cart?view=hulkapps_cart_collections.json';
    DEBUG = true;

    constructor() {
        this.shippingElSelector = '[data-hulkapps-shipping]';
        this.messageSelector = '.order-shipping';

        this.shippingNotReachedTemplate =
            `<p style="text-align:center">Spend <span>{{amount}}</span> more to unlock free shipping!</p>`;
        this.shippingReachedTemplate =
            `<p style="text-align:center">Congratulations! You are eligible for "FREE SHIPPING"</p>`;

        this.init();
    }

    /* ---------------------------------------------------------
     * INITIALIZATION
     * ---------------------------------------------------------
     */

    init() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            window.requestAnimationFrame(() => this.updateShippingData());
        });

        window.addEventListener('hulkapps-shipping-integration:cart-drawer', () => {
            setTimeout(()=>{
                this.updateShippingData();
            },500);
        });

        console.log('[HulkShippingIntegration] | Loaded');
    }

    log(...args) {
        if (this.DEBUG) console.log("[HulkShippingIntegration]", ...args);
    }

    /* ---------------------------------------------------------
     * HELPERS
     * ---------------------------------------------------------
     */

    debounce(fn, delay = 50) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn(...args), delay);
        };
    }

    async updateCartObject() {
        const ts = Date.now();
        const res = await fetch(`/cart.js?ts=${ts}`);
        const data = await res.json();
        this.log('Cart object:', data);
        window.hulkapps.cart = data;
    }

    appendFormData(formData, key, value) {
        if (value === null || value === undefined) return;

        // Handle arrays
        if (Array.isArray(value)) {
            value.forEach((val, i) => {
                this.appendFormData(formData, `${key}[${i}]`, val);
            });
            return;
        }

        // Handle objects
        if (typeof value === "object" && !(value instanceof File)) {
            Object.keys(value).forEach(subKey => {
                this.appendFormData(formData, `${key}[${subKey}]`, value[subKey]);
            });
            return;
        }

        // Primitive values
        formData.append(key, value);
    }

    checkForDiscountCode(formData) {
        const discountCode = localStorage.getItem('discount_code');

        if (discountCode) {
            this.log("Applying discount:", discountCode);

            const input = document.querySelector(".hulkapps_discount_code");
            if (input) input.value = discountCode;

            formData.append("discount_code", discountCode);
        }

        return formData;
    }

    getValidUrl() {
        if (window.hulkapps.is_volume_discount) {
            return `${window.hulkapps.vd_url}/shop/get_cart_details`;
        }
        if (window.hulkapps.is_product_options) {
            return `${window.hulkapps.po_url}/store/get_cart_details`;
        }
        return null;
    }

    async getCartCollections() {
        try {
            const res = await fetch(this.HULKAPPS_CART_COLLECTIONS_URL);
            if (!res.ok) throw new Error("Failed to load collections");

            const data = await res.json();

            data.items.forEach(item => {
                window.hulkapps.cart_collections[item.variant_id] = item.product_collections;
                window.hulkapps.product_tags[item.product_id] = item.product_tags;
            });

        } catch (err) {
            console.error("Error in getCartCollections:", err);
        }
    }

    async getCartDetails() {
        try {
            await this.updateCartObject();

            const url = this.getValidUrl();
            if (!url) {
                this.log("No valid HulkApps URL found, aborting.");
                return null;
            }

            const formData = new FormData();

            this.appendFormData(formData, "cart_data", window.hulkapps);
            formData.append("store_id", window.hulkapps.store_id);
            formData.append("cart_collections", JSON.stringify(window.hulkapps.cart_collections));
            formData.append("cart_product_tags", JSON.stringify(window.hulkapps.product_tags));
            formData.append("ctags", window.hulkapps.customer?.tags ?? "");
            formData.append("currency_rate", Shopify.currency.rate || 1);

            this.checkForDiscountCode(formData);

            const res = await fetch(url, {
                method: "POST",
                body: formData
            });

            if (!res.ok) throw new Error("Failed POST for cart details");

            const response = await res.json();
            return response.discounts ?? null;

        } catch (err) {
            console.error("Error in getCartDetails:", err);
            return null;
        }
    }

    /* ---------------------------------------------------------
     * SHIPPING LOGIC
     * ---------------------------------------------------------
     */

    async updateShippingData() {
        const shippingEl = document.querySelector(this.shippingElSelector);
        if (!shippingEl) {
            this.log("Shipping element not found, skipping.");
            return;
        }

        const goal = parseFloat(shippingEl.dataset.hulkappsShipping);
        if (isNaN(goal)) {
            this.log("Invalid or missing shipping goal");
            return;
        }

        const data = await this.getCartDetails();
        if (!data) {
            this.log("No cart data received.");
            return;
        }

        const original = parseFloat(data.original_line_price_total);
        const discounted = parseFloat(data.discounted_line_price_total);

        this.log("Original:", original, "Discounted:", discounted);

        const messageEl = shippingEl.querySelector(this.messageSelector);
        if (!messageEl) {
            this.log("Message element missing.");
            return;
        }

        const progressBar = document.querySelector('.progress-bar progress');

        // If no discount – leave the bar unchanged
        if (!(discounted < original)) {
            this.log("No discount applied. Leaving shipping bar unchanged.");
            return;
        }

        // Shipping not yet reached
        if (discounted < goal) {
            const difference = (goal - discounted).toFixed(2);
            const formatted = window.hulkapps.money_format.replace('{{amount}}', difference);
            const message = this.shippingNotReachedTemplate.replace('{{amount}}', formatted);

            messageEl.innerHTML = message;

            if (progressBar) {
                progressBar.max = goal;
                progressBar.value = discounted;
            }

            this.log("Shipping NOT reached:", message);
            return;
        }

        // Shipping reached
        messageEl.innerHTML = this.shippingReachedTemplate;

        if (progressBar) {
            progressBar.max = goal;
            progressBar.value = goal;
        }

        this.log("Shipping reached!");
    }
}

if (document.readyState === 'complete'){
    new HulkAppsShippingIntegration();
} else {
    document.addEventListener('DOMContentLoaded',()=>{
        new HulkAppsShippingIntegration();
    })
}